import BIGQUERY from './BIGQUERY'
import FIRESTORE from './FIRESTORE'
import PUB_SUB from './PUB_SUB'
import REALTIME_DATABASE from './REALTIME_DATABASE'

export default {
  BIGQUERY,
  FIRESTORE,
  PUB_SUB,
  REALTIME_DATABASE,
}
